import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { bonusById as orgConfig } from 'org/configs/modules.config';
import { BONUS_BY_ID_GET_SUCCESS, BONUS_BY_ID_GET_FAILURE } from '../actions/types';

const defaultConfig = {
  defaults: {
    api: {
      params: {},
      options: {
        success: BONUS_BY_ID_GET_SUCCESS,
        failure: BONUS_BY_ID_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
      },
    },
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
